/* eslint-disable camelcase */
import { useState, useEffect } from 'react';
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';

export interface UserData {
  userId: string;
  displayName: string;
  teamIds: string[];
  roles: string[];
  email: string;
}

const useUser = (): UserData => {
  const [userData, setUserData] = useState<UserData>({
    userId: '',
    displayName: 'Unknown User',
    teamIds: [],
    roles: [],
    email: '',
  });

  useEffect(() => {
    const fetchUserData = async () => {
      const session = await fetchAuthSession();
      if (!session.tokens) {
        return;
      }
      const currentUser = await getCurrentUser();

      const attributes = session.tokens?.idToken?.payload || {};
      const {
        given_name, family_name, sub, email,
      } = attributes;

      const { username } = currentUser;

      let displayName = 'Unknown User';
      if (given_name && family_name) {
        displayName = `${given_name} ${family_name}`;
      } else if (username) {
        displayName = username.split(/[ _]/).map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
      }

      const cognitoGroups = attributes['cognito:groups'] as string[] | undefined;

      setUserData({
        userId: sub ?? '',
        displayName,
        teamIds: (cognitoGroups ?? [])
          .filter((g) => g.endsWith(':read'))
          .map((g) => g.replace(':read', '')),
        roles: cognitoGroups || [],
        email: typeof email === 'string' ? email : '',
      });
    };

    fetchUserData();
  }, []);

  return userData;
};

export default useUser;
